import { render, staticRenderFns } from "./QuotationCard.vue?vue&type=template&id=4ba03232"
import script from "./QuotationCard.vue?vue&type=script&lang=js"
export * from "./QuotationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports